<template>
    <div class="file-uploader-new-container">
        <div ref="cropper" id="cropper-container" />

        <div :style="styleList">
            <p class="text-semi-dark">
                Use up to 4 photos to show your item’s most important qualities.
            </p>

            <div class="validation" style="width: calc(126px + 80px);">
                <div class="d-flex justify-content-between">
                    <span class="text-sm text-muted text-left">Cover Size</span>
                    <strong class="text-sm text-left">{{ $t('logos.dimensions') }}</strong>
                </div>

                <div class="d-flex justify-content-between">
                    <span class="text-sm text-muted text-left">{{ $t('logos.fileSize') }}</span>
                    <strong class="text-sm text-left">{{ $t('logos.byteSize') }}</strong>
                </div>

                <div class="d-flex justify-content-between">
                    <span class="text-sm text-muted text-left">{{ $t('logos.formats') }}</span>
                    <strong class="text-sm text-left">{{ $t('logos.extensions') }}</strong>
                </div>
            </div>

            <div class="file-uploader">
                <div class="file-select">
                    <label class="" for="upload-multiple">
                        <span class="ech-icon icon-upload-default" />
                        <p class="upload-description">Drag <br> Image Here</p>
                        <span class="color-green">Browse</span>
                        <input id="upload-multiple" class="upload-multiple" ref="file" type="file" @change="handleFileUpload()">
                    </label>
                </div>

                <div class="uploading" ref="queue" />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import FileUploaderProcessorNewVersion from './inputFileProcessorNewVersion';

export default {
    props: {
        styleList: {
            type: Object,
            default: () => ({}),
        },
        crop: {
            type: Object,
            default: () => {
                return {
                    enable: false,
                    ref: null,
                };
            },
        },
    },
    data () {
        return {
            files: '',
        };
    },

    methods: {
        handleFileUpload () {
            try {
                this.files = this.$refs.file.files;

                const FileProcessor = Vue.extend(FileUploaderProcessorNewVersion);
                const instance = new FileProcessor({
                    propsData: {
                        file: this.files[this.files.length - 1],
                        crop: this.crop,
                    },
                });

                instance.$mount();

                this.$refs.queue.appendChild(instance.$el);
            } catch (e) {

            }
        },
    },
};
</script>
